import { Role } from 'interfaces/types'

import { Comment, CommentApi, Post, PostApi } from '../interfaces/types'

export const formatComment = (data: CommentApi | null): Comment => {
  if (!data) return {} as Comment

  return {
    content: data.content,
    countLikes: data.likes_count,
    countReplies: data.replies_count,
    createdAt: data.created_at,
    createdTime: data.created_time,
    id: String(data.id),
    images: data.image || [],
    link: data.link || null,
    replies:
      data.replies && data.replies.length > 0
        ? data.replies.map(formatComment)
        : [],
    author: {
      id: data.user?.id || 0,
      username: data.user?.user_name || '',
      name: data.user?.name || '',
      role: data.user?.role
        ? (data.user?.role?.toLowerCase() as Role)
        : ('' as Role),
      avatar: data.user?.avatar || '',
      type: data.user?.type || '',
      email: data.user?.email || '',
      title: data.user?.title || '',
      partnerId: data.user?.partner_id ? String(data.user?.partner_id) : '',
      doctorId: data.user?.doctor_id ? String(data.user?.doctor_id) : '',
      hospitalId: data.user?.hospital_id ? String(data.user?.hospital_id) : '',
    },
    liked: !!data.liked,
    mentionedUser: data.mentioned
      ? {
          id: data.mentioned?.id || 0,
          username: data.mentioned?.user_name || '',
          name: data.mentioned?.name || '',
          role: data.mentioned?.role
            ? (data.mentioned?.role?.toLowerCase() as Role)
            : ('' as Role),
          avatar: data.mentioned?.avatar || '',
          type: data.mentioned?.type || '',
          email: data.mentioned?.email || '',
          title: data.mentioned?.title || '',
          partnerId: data.mentioned?.partner_id
            ? String(data.mentioned?.partner_id)
            : '',
          doctorId: data.mentioned?.doctor_id
            ? String(data.mentioned?.doctor_id)
            : '',
          hospitalId: data.mentioned?.hospital_id
            ? String(data.mentioned?.hospital_id)
            : '',
        }
      : null,
    mentions: data.mentions || [],
    isSensitive: data.is_sensitive || 0,
    userReadComment: data.user_read_comment,
    source: data.source || [],
    isVerify: data.is_verify || 0,
    isOppose: data.is_oppose || 0,
    userVerify: data.user_verify || {},
    categorySlug: data.categories || '',
  } as any
}

export const formatPost = (post: PostApi): Post => {
  if (!post) return {} as Post

  return {
    id: `${post.id}`,
    topics:
      post.topics?.map((topic: any) => ({
        id: String(topic.id),
        name: topic.name,
        slug: topic.slug,
        url: '/' + post.community?.slug + '/' + topic.slug,
        communityId: String(post.community?.id),
        communitySlug: post.community?.slug,
        communityName: post.community?.name,
        isHidden: Boolean(topic.is_hidden),
        isActive: true,
      })) || [],
    community: {
      id: String(post.community?.id),
      name: post.community?.name,
      slug: post.community?.slug,
      isActive: true,
      isHidden: Boolean(post.community?.is_hidden),
      description: post.community?.description,
    },
    slug: post.slug,
    author: {
      id: post.user?.id || 0,
      username: post.user?.user_name || '',
      email: post.user?.email || '',
      name: post.user?.name || '',
      avatar: post.user?.avatar || '',
      role: post.user?.role
        ? (post.user?.role?.toLowerCase() as Role)
        : ('' as Role),
      type: post.user?.type || '',
      title: post.user?.title || '',
      partnerId: post.user?.partner_id ? String(post.user?.partner_id) : '',
      doctorId: post.user?.doctor_id ? String(post.user?.doctor_id) : '',
      hospitalId: post.user?.hospital_id ? String(post.user?.hospital_id) : '',
    },
    previewUrl: {
      title: post.preview_title || '',
      url: post.preview_link || '',
      image: post.preview_image || '',
      description: post.preview_description || '',
    },
    createdDate: post.created_at || '',
    scheduleDate: post.schedule_datetime || '',
    photos: post.images || [],
    description: post.description || '',
    commentCount: post.comments_count || 0,
    likeCount: post.likes_count || 0,
    title: post.name || '',
    isPin: !!post.is_pin,
    pinDate: post.pin_date || '',
    isLiked: post.liked || false,
    bookmarked: Boolean(post.bookmarked) || false,
    mentions: post.mentions || [],
    commented: Boolean(post.commented) || false,
    introUrl: post.intro_url || '',
    bannerImage: post.banner_image || '',
    isAnonymous: post.is_anonymous || 0,
    isSensitive: post.is_sensitive || 0,
    // authorExpertId: post.author_expert_id ? String(post.author_expert_id) : '',
  }
}
